const API_ROUTES = {
  DEFAULT_ROUTE: "/mapview",
  get LOAD_MORE() {
    return `${this.DEFAULT_ROUTE}/more`;
  },
};

export default API_ROUTES;
